module.exports = __webpack_public_path__ + "media/components/icons/SVG/play-22fe5ca5695b271d90a996e0894c2101.svg";